import * as React from 'react';
import { IconHeartOn16, IconHeartOff16 } from '@cian/ui-kit';

import { HeaderButton, IHeaderButtonProps } from '../HeaderButton';

interface IFavoriteButtonProps extends IHeaderButtonProps {
  active: boolean;
}

export const FavoriteButton: React.FC<IFavoriteButtonProps> = ({ active, ...props }) => (
  <HeaderButton {...props} dataTestId="FavoriteButton">
    {active ? <IconHeartOn16 color="error_100" /> : <IconHeartOff16 color="gray_icons_100" />}
  </HeaderButton>
);
